/**
 * Extract all tracking parameters, consent status, and cross-device IDs
 * into a key-value object ready to be posted to Laravel API.
 * 
 * @returns {Object} Tracking payload object
 */
function getTrackingPayload() {
    var payload = {};

    // Helper 1: Parse URL query parameters into an object
    function getUrlParams() {
        var params = {};
        var queryString = window.location.search.substring(1);
        if (!queryString) return params;

        var pairs = queryString.split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            if (pair[0]) {
                params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
            }
        }
        return params;
    }

    // Helper 2: Retrieve a browser cookie by name
    function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length === 2) return parts.pop().split(";").shift();
        return null;
    }

    // Helper 3: Extract Google Analytics client ID (_ga)
    function getGAClientId() {
        var gaCookie = getCookie('_ga');
        if (!gaCookie) return null;
        var parts = gaCookie.split('.');
        if (parts.length >= 4) {
            return parts.slice(2).join('.');
        }
        return gaCookie;
    }

    var urlParams = getUrlParams();

    // 1. Consent Status Check
    var cookies = document.cookie || '';
    var hasMetaConsent = false;
    if (cookies.indexOf('__cmpcvc=') !== -1) {
        var cmpCvc = cookies.split('__cmpcvc=')[1].split(';')[0];
        if (cmpCvc.indexOf('_s7_') !== -1) {
            hasMetaConsent = true;
        }
    }
    payload['_cmp_marketing'] = hasMetaConsent ? '1' : '0';

    // 2. Email Marketing Cross-Device Recovery
    if (urlParams['cmp_fbp']) {
        payload['_cmp_fbp'] = urlParams['cmp_fbp'];
    }
    if (urlParams['cmp_ga_client_id']) {
        payload['_cmp_ga_client_id'] = urlParams['cmp_ga_client_id'];
    }
    if (urlParams['ref_free_order']) {
        payload['_cmp_ref_free_order'] = urlParams['ref_free_order'];
    }

    // 3. Google Analytics Client ID (_ga)
    var gaClientId = getGAClientId() || urlParams['cmp_ga_client_id'];
    if (gaClientId) {
        payload['_cmp_ga_client_id'] = gaClientId;
        try { sessionStorage.setItem('cmp_ga_client_id', gaClientId); } catch (e) {}
    } else {
        try {
            var storedGaId = sessionStorage.getItem('cmp_ga_client_id');
            if (storedGaId) payload['_cmp_ga_client_id'] = storedGaId;
        } catch (e) {}
    }

    // 4. Tracking Parameters (UTMs, Click IDs)
    var trackingKeys = [
        'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
        'fbclid', 'gclid', 'gbraid', 'wbraid'
    ];

    trackingKeys.forEach(function(key) {
        if (urlParams[key]) {
            payload['_cmp_' + key] = urlParams[key];
            try {
                sessionStorage.setItem('cmp_' + key, urlParams[key]);
            } catch (e) {}

            if (key === 'fbclid') {
                var ts = Date.now().toString();
                payload['_cmp_fbclid_ts'] = ts;
                try { sessionStorage.setItem('cmp_fbclid_ts', ts); } catch (e) {}
            }
        } else {
            try {
                var storedVal = sessionStorage.getItem('cmp_' + key);
                if (storedVal) {
                    payload['_cmp_' + key] = storedVal;
                    if (key === 'fbclid') {
                        var storedTs = sessionStorage.getItem('cmp_fbclid_ts');
                        if (storedTs) payload['_cmp_fbclid_ts'] = storedTs;
                    }
                }
            } catch (e) {}
        }
    });

    // 5. Read Facebook Browser Cookie (_fbp)
    if (!payload['_cmp_fbp']) {
        var fbpCookie = getCookie('_fbp');
        if (fbpCookie) {
            payload['_cmp_fbp'] = fbpCookie;
        }
    }

    return payload;
}